// extracted by mini-css-extract-plugin
export default {"container":"Udp2Ax4PSJPe2DSGpRrs"};